export const API_HOST = 'import.meta.env.VITE_API_URL';
export const config = {
	appName: 'Erik Web Page',
	localStorageStateName: 'erik-state',
	rootElement: 'app',
};
